module.exports = __webpack_public_path__ + "static/media/idBackground.9b77ef51.png";